<template>
  <div>
    <PartnerHeader :img_header="header_image" header="รายงานยอดขายของร้านค้าลูกค้าขายส่ง" link_back="managepos"/>
    <MenuPartner/>
    <report_wholesale/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/chart_four.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import report_wholesale from "@/components/admin/manage_pos/wholesale_store_setting/Report_wholesale";
export default {
  name: "ReportWholesale",
  components: {
    PartnerHeader,
    report_wholesale,
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
